module.exports = __webpack_public_path__ + "img/equiply-logo-transparent.cf4cc6d9.png";